<button class="common-button__icon-sm-noborder"
    [pTooltip]="tooltipContent"
    [escape]="false"
    [autoHide]="false"
    tooltipPosition="top">
    <i class="lf-icon-document common-icon__md"></i>
</button>
<ng-template #tooltipContent>
  <div class="common-tooltip__content-box">
    <p class="common-tooltip__content-box-text"
      [afTranslate]="'field-items.show-in-report'">
      _Se mostrará en los informes:
    </p>
    <ul class="common-tooltip__content-inner-box">
      @for(fieldInReport of inReport; track $index){
        <li class="common-tooltip__content-box-text">{{fieldInReport}}</li>
      }
    </ul>
  </div>
</ng-template>
